module.exports = __webpack_public_path__ + "static/3-routines-ux-ebb33b707e341ceae563cb049068244e.png";